import { render, staticRenderFns } from "./CreateStoryViewController.vue?vue&type=template&id=4bd4ec62&"
import script from "./CreateStoryViewController.vue?vue&type=script&lang=ts&"
export * from "./CreateStoryViewController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports